import styled from 'styled-components';
import SeH004B from 'dc/SeH004B';
import Wra16A from 'dc/Wra16A';
import Load03 from 'dc/Load03';
import ChStPrt2 from 'dc/ChStPrt2';

export const Wrapper = styled.div`
  width: 672px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: stretch;
  background-color: #fff;
  border-radius: 4px;
`;

export const Header = styled(SeH004B)`
  background-color: #f4f7f9;
`;

export const NumberWrapper = styled(Wra16A)`
  text-align: left;
  border-bottom: 1px solid rgba(38, 50, 56, 0.12);
`;

export const StatsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const TranslateWrapper = styled.div`
  width: 320px;
  margin-right: 32px;
`;

type ListContainerProps = {
  $points?: boolean;
};

export const ListContainer = styled.div<ListContainerProps>`
  width: ${props => (props.$points ? '424px' : '320px')};
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background-color: transparent;
  height: 302px;
  overflow-y: auto;
  div div div div span:first-child {
    width: 160px;
  }
`;

export const Loader = styled(Load03)`
  background-color: transparent;
`;

export const SectionList = styled(ChStPrt2)``;
